export interface PropertyFilter {
    by?: PropertyFilter.TypeEnum;
    data?: Array<string>;
    label_id?: string; // ID pour les traductions de label
    tooltip_id?: string; // ID pour les tooltips de traduction
    label?: string; // Label par défaut
    name?: string; // Nom alternatif
  }
  export namespace PropertyFilter {
    export type TypeEnum =
      | "PRODUCT_IDS"
      | "PRODUCT_ID"
      | "CATEGORY_IDS"
      | "PARENT_ID";
    export const TypeEnum = {
      PRODUCT_IDS: "PRODUCT_IDS" as TypeEnum,
      PRODUCT_ID: "PRODUCT_ID" as TypeEnum,
      CATEGORY_IDS: "CATEGORY_IDS" as TypeEnum,
      PARENT_ID: "PARENT_ID" as TypeEnum,
    };
  }
  